import {connect} from 'react-redux';
import {Component} from "react";
import * as React from "react";
import {Field} from "redux-form";
import {Label} from "reactstrap";

/**
 * Vlastní field typu radio.
 *
 * POZOR: vrací vždy string hodnotu!
 */
class RadioField extends Component {

    render() {
        const {label, value, ...other} = this.props;

        return <Label className="form-radio-label">
            <Field component="input" type="radio" parse={RadioField.parse} value={value ? value.toString() : value} {...other}/>
            <span>{label}</span>
        </Label>
    }
}

export default connect()(RadioField);
